export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { itApplicationOwner: entityDetails?.applicationManager },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        applicationOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        applicationOwnerDetails: {
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
            gpid: entityDetails?.applicationManagerGpid,
        },
        entityDetails: {
            ...entityDetails,
            applicationOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            applicationOwnerDetails: {
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
                gpid: entityDetails?.applicationManagerGpid,
            },
            costCenter: entityDetails?.costCenter,
            projectName: entityDetails?.project,
            sector: entityDetails?.sector,
        },
        tagsQc: { ...catalogConfig?.tags },
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.applicationShortName,
        sector: entityDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        region: catalogConfig?.applicationRegion || null,
        regionDetails: { label: catalogConfig?.applicationRegion || null, value: catalogConfig?.applicationRegion || null },
        program: catalogConfig?.program || null,
        programDetails: { label: catalogConfig?.program || null, value: catalogConfig?.program || null },
        department: catalogConfig?.department,
        departmentDetails: { label: catalogConfig?.department || null, value: catalogConfig?.department || null },
        cluster: catalogConfig?.eksClusterName,
        clusterDetails: { label: catalogConfig?.eksClusterName, value: catalogConfig?.eksClusterName },
        istioGatewayUrl: catalogConfig?.istioGatewayUrl || null,
        clusterRegion: environmentDetails?.region || null,
        awsAccountId: environmentDetails?.awsAccountId || null,
        size: catalogConfig?.size || null,
        appSupportMailId: catalogConfig?.appSupportMailId,
        project: catalogConfig?.project,
        eksNamespace: catalogConfig?.eksNamespace,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        adGroup: catalogConfig?.adGroup || null,
        resourceGroup: environmentDetails?.resourceGroup || null,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;

    return {
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { itApplicationOwner: entityDetails?.applicationManager },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        applicationOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        applicationOwnerDetails: {
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
            gpid: entityDetails?.applicationManagerGpid,
        },
        entityDetails: {
            ...entityDetails,
            applicationOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            applicationOwnerDetails: {
                name: entityDetails?.applicationManager,
                email: entityDetails?.applicationManagerEmail,
                gpid: entityDetails?.applicationManagerGpid,
            },
            costCenter: entityDetails?.costCenter,
            recoveryPriority: entityDetails?.recoveryPriority,
            projectName: entityDetails?.project,
            sector: catalog?.sector,
        },
        estimatedCost: { ...data?.itemDetail?.estimatedCost },
        tagsQc: { ...catalogConfig?.tags },
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.applicationShortName,
        sector: entityDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        region: catalogConfig?.applicationRegion || null,
        regionDetails: { label: catalogConfig?.applicationRegion || null, value: catalogConfig?.applicationRegion || null },
        program: catalogConfig?.program || null,
        programDetails: { label: catalogConfig?.program || null, value: catalogConfig?.program || null },
        department: catalogConfig?.department,
        departmentDetails: { label: catalogConfig?.department, value: catalogConfig?.department },
        cluster: catalogConfig?.eksClusterName,
        clusterDetails: { label: catalogConfig?.eksClusterName, value: catalogConfig?.eksClusterName },
        istioGatewayUrl: catalogConfig?.istioGatewayUrl || '',
        clusterRegion: environmentDetails?.region || '',
        awsAccountId: environmentDetails?.awsAccountId || '',
        size: catalogConfig?.size || null,
        appSupportMailId: catalogConfig?.appSupportMailId,
        project: catalogConfig?.project,
        eksNamespace: catalogConfig?.eksNamespace,
        resourceGroup: environmentDetails?.resourceGroup || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        adGroup: catalogConfig?.adGroup || null,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    entityDetails: null,
    applicationName: null,
    appShortName: null,
    sector: null,
    environment: null,
    size: null,
    region: null,
    regionDetails: null,
    program: null,
    programDetails: null,
    applicationOwner: null,
    applicationOwnerDetails: null,
    requestType: '',
    department: null,
    departmentDetails: null,
    appSupportMailId: null,
    cluster: null,
    clusterDetails: null,
    project: null,
    hCode: null,
    hCodeDetails: null,
    adGroup: null,
    envDetails: null,
    tags: [],
    estimatedCost: {},
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isDiskOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};
